import styles from './index.module.scss';
import Typography from '@primitives/Typography/Typography';
import { Link } from 'react-router-dom';

function Content() {
  return (
    <div className={styles.content}>
      <Typography variant="p5" color="var(--navi-color-navigation-blue-bg-secondary)">
        Please follow the below mentioned instructions:
      </Typography>
      <ul>
        <li>
          <Typography variant="p5" color="var(--navi-color-navigation-blue-bg-secondary)">
            Make sure you are logged in to COSMOS on the device assigned to you.
          </Typography>
        </li>
        <li>
          <Typography variant="p5" color="var(--navi-color-navigation-blue-bg-secondary)">
            Make sure the app is running in the background.
          </Typography>
        </li>
        <li>
          <Typography variant="p5" color="var(--navi-color-navigation-blue-bg-secondary)">
            Make sure you are connected to wifi.
          </Typography>
        </li>
        <li>
          <Typography variant="p5" color="var(--navi-color-navigation-blue-bg-secondary)">
            Make sure that you have given all the mandatory permissions requested on the app.
          </Typography>
        </li>
        <li>
          <Typography variant="p5" color="var(--navi-color-navigation-blue-bg-secondary)">
            Make sure you have given unrestricted access for battery usage, refer to{' '}
            <Link
              to="https://docs.google.com/document/d/1MjCSt0-JZKamOjciILbMa8q8YWsHSBRRHWLE7jfTx6U/edit"
              style={{ color: 'blue', textDecoration: 'none' }}
              className="underline"
              target="_blank"
              rel="noopener noreferrer"
            >
              this document
            </Link>{' '}
            for more details.
          </Typography>
        </li>
      </ul>
      <Typography variant="p5" color="var(--navi-color-navigation-blue-bg-secondary)">
        In case you are not auto logged in, please click below
      </Typography>
    </div>
  );
}

export default Content;
